<template>
  <div class="map-wrapper">
    <div ref="map" class="map"></div>

    <!-- <div class="search-box">
      <input
        ref="searchInput"
        v-model="search"
        type="text"
        placeholder="Buscar lugar"
      />
    </div> -->
  </div>
</template>

<script>
import { mapID, loadGoogleMaps } from '../../services/googleMapsLoader'

export default {
  props: {
    coordinates: {
      type: Object,
      default: () => ({ lat: 9.946588, lng: -84.075483 })
    }
  },

  data() {
    return {
      map: null,
      marker: null,
      search: ''
    }
  },

  async mounted() {
    const google = await loadGoogleMaps()

    this.initMap(google)
  },

  watch: {
    coordinates: {
      deep: true,
      handler(val) {
        if (!this.map || !this.marker) return

        const pos = {
          lat: Number(val.lat),
          lng: Number(val.lng)
        }

        this.marker.position = pos
        this.map.setCenter(pos)
      }
    }
  },

  methods: {
    initMap(google) {
      const center = {
        lat: Number(this.coordinates.lat),
        lng: Number(this.coordinates.lng)
      }

      this.map = new google.maps.Map(this.$refs.map, {
        center,
        zoom: 15,
        mapId: mapID()
      })

      this.marker = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: center,
        gmpDraggable: true
      })

      const markerEl = this.marker.content
      markerEl.addEventListener('pointerup', () => {
        const pos = this.marker.position

        const coords = {
          lat: typeof pos.lat === 'function' ? pos.lat() : pos.lat,
          lng: typeof pos.lng === 'function' ? pos.lng() : pos.lng
        }

        this.emitCoords(coords)
      })

      // click en mapa
      // this.map.addListener('click', (e) => {
      //   const coords = {
      //     lat: e.latLng.lat(),
      //     lng: e.latLng.lng()
      //   }

      //   this.marker.position = coords
      //   this.emitCoords(coords)
      // })
    },
    // initAutocomplete(google) {
    //   const input = this.$refs.searchInput

    //   if (!input) return

    //   const autocomplete = new google.maps.places.Autocomplete(input, {
    //     fields: ['geometry', 'name']
    //   })

    //   autocomplete.bindTo('bounds', this.map)

    //   autocomplete.addListener('place_changed', () => {
    //     const place = autocomplete.getPlace()

    //     if (!place.geometry) return

    //     const loc = {
    //       lat: place.geometry.location.lat(),
    //       lng: place.geometry.location.lng()
    //     }

    //     this.map.setCenter(loc)
    //     this.map.setZoom(16)

    //     this.marker.position = loc
    //     this.emitCoords(loc)
    //   })
    // },
    emitCoords(coords) {
      this.$emit('update-coordinates', {
        lat: Number(coords.lat.toFixed(6)),
        lng: Number(coords.lng.toFixed(6))
      })
    }
  }
}
</script>

<style scoped>
.map-wrapper {
  position: relative;
  width: 100%;
}

.map {
  height: 400px;
  width: 100%;
  border-radius: 8px;
}

.search-box {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

.search-box input {
  width: 280px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 14px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  outline: none;
}
</style>
